import React, { Fragment, useEffect, useState } from "react";
import BlockHeader from "../../component/BlockHeader/BlockHeader";
import { useSearchParams } from "react-router-dom";
import { popinfo } from "../../component/Fancybox/Fancybox";
import axios from 'axios';
import _ from "lodash";
import api from "../../api";
import "./PageRegistrationGetStarted.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default () => {
    let navigate        = useNavigate();
    let location        = useLocation();

    const [myAction, setMyAction] = useState('browse');

    const LetsGo = () => {
        switch(myAction)
        {
            case 'create':
                navigate('/profile');
                break;
            case 'browse':
                navigate('/initiative');
                break;
        }
    };
    return (
        <div id="registration-get-started" className="container w-800">
            <span className=" text-sm block mb-md">Step 3 of 3</span>
            <BlockHeader title="Welcome to Crowdbees" desc="Congratulations, your account is active. welcome and good luck"/>
            <ul className="action-options">
                <li className={"action-option " + (myAction === 'create' ? 'selected' : '') }>
                    <div className="wrapper" onClick={() => {setMyAction('create')}}>
                        <h2 className="action-title">Complete Portofolios</h2>
                        <div className="leading-text text-sm">
                            Complete your biography and portfolio to make it easier for other users to see your work
                        </div>
                    </div>
                </li>
                <li className={"action-option " + (myAction === 'browse' ? 'selected' : '') }>
                    <div className="wrapper" onClick={() => {setMyAction('browse')}}>
                        <h2 className="action-title">Browse Initiative</h2>
                        <div className="leading-text text-sm">
                        Start by looking for various interesting initiatives on crowdbees.
                        </div>
                    </div>
                </li>
            </ul>
            <div className="flex-flat mt-md">
                <div>
                    
                    <Link to={'/registration/declare-interest' + location.search}>
                        <button className="btn ">Prev</button>
                    </Link>
                </div>
                <div className="text-right">
                    <button className="btn btn-orange" onClick={LetsGo}>Finish</button>
                </div>
            </div>
        </div>
    )
}